function Marker() {}

export default Marker
